import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { GreenLeafReportListing } from './Pages'

export const GreenLeafWithOverKGReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={GreenLeafReportListing} />
    </Fragment>
)